import React from "react";
import { sizeMapping } from "../utils/mappings";
import { Size } from "../utils/types";

interface AvatarProps {
  size?: Size;
}

const Avatar = ({ size = "m" }: AvatarProps) => {
  const imageClass = `${sizeMapping[size]} rounded-full inline-block `;

  return (
    <img
      className={imageClass}
      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
      alt=""
    />
  );
};

export default Avatar;
